import React from "react";
import logo from "./logo.svg";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  withRouter,
} from "react-router-dom";

import "./App.css";
import Home from "./Home";
import OrderSubmit from "./components/order/OrderSubmit";
import OrderPayment from "./components/order/OrderPayment";
import OrderThankYou from "./components/order/OrderThankYou";
import { Fragment } from "react";

function App(props) {
  const data = props.data;
  return (
    <Fragment>
      <Switch>
        <Route exact path={"/"}>
          <OrderSubmit data={data} />
        </Route>
        <Route path={"/payment/:orderId"}>
          <OrderPayment data={data} />
        </Route>
        <Route path={"/thankyou"}>
          <OrderThankYou data={data} />
        </Route>
        <Route path="/home">
          <Home data={data} />
        </Route>
      </Switch>
    </Fragment>
  );
}

export default withRouter(App);
